import Loader from "@/components/Loader/Loader";
import PermissionChecker from "@/components/PrivacyComponent/PermissionChecker";
import GetAllAgents from "@/components/CRM/Company/GetAllAgents";
import DetailsCompany from "@/components/CRM/Company/DetailsCompany";
import { Suspense } from "react";
import { Route } from "react-router-dom";

const AgentRoutes = [
    <Route
        path="agent"
        element={
            <Suspense fallback={<Loader />}>
                <PermissionChecker permission={["readAll-agent", "readSingle-agent"]}>
                    <GetAllAgents />
                </PermissionChecker>
            </Suspense>
        }
        key="agent-list"
    />,
    <Route
        path="agent/:id"
        element={
            <Suspense fallback={<Loader />}>
                <PermissionChecker permission={["readAll-agent", "readSingle-agent"]}>
                    <DetailsCompany />
                </PermissionChecker>
            </Suspense>
        }
        key="agent-detail"
    />,
];

export default AgentRoutes;
